import React from 'react'

import ICONS from '../../media/icons'

const SVGIcon = ({ name, ...rest }) => {
  const Component = ICONS[name] || ICONS['jow-64']
  return <Component {...rest} />
}

export default SVGIcon
